import * as React from "react";
import { WithToast, Loader, withToast, ListView, BPMAlbum, PlayerState, PLAY_SMALL_SVG, PLAY_SMALL_WHITE_SVG, PAUSE_SMALL_SVG, PAUSE_SMALL_WHITE_SVG, CrateContextConsumer } from 'bpm-web-generic';
import { RouteComponentProps, withRouter } from "react-router";
import { apiAlbumToBPMAlbum } from "src/transformer";
import { mediaAPI } from "src/api/config";
import { SortByQueryOptions } from "src/api/download-api-sdk/src";

class ScratchTools extends React.Component<WithToast & RouteComponentProps, { albums?: BPMAlbum[] }> {
    constructor(props: WithToast & RouteComponentProps) {
        super(props)
        this.state = {

        }
    }
    componentDidMount() {
        mediaAPI.searchAlbum(160, 0, 'DJ-Tools', 'music', undefined, undefined, '0', undefined, undefined, undefined, undefined, undefined, SortByQueryOptions.DateDesc).then(({ data }: any) => {
            this.setState({ albums: data.map(apiAlbumToBPMAlbum) })
        }).catch(err => {
            this.props.showToast('danger', 'Sorry, something went wrong. Please try again.')
        })
    }

    public render() {
        if (!this.state.albums) {
            return <Loader />
        } else {
            const self = this
            return <ListView {...this.props} artistColumn className='inline-list' contentType={'audio'} title={'Scratch Tools'} hide={{ mediaRows: true }}
                albums={this.state.albums}
                context={'scratch_tools'}
                renderer={{
                    moreColumn: function (this: ListView, album: BPMAlbum, addingToCrate: string | undefined, dowloadingMedia: string | undefined) {
                        const media = album.media[0]
                        return <div className="col-download hide-mobile" style={{ width: 60 }}>
                            <div className={"row-download " + (dowloadingMedia && dowloadingMedia == media.id ? 'downloading' : '')} style={{ marginRight: 4 }}>
                                <div className="download" onClick={(e) => {
                                    e.stopPropagation()
                                    this.downloadMedia(media, e.currentTarget)
                                }}>
                                    {dowloadingMedia && dowloadingMedia == media.id && <Loader size={25} />}
                                </div>
                                <CrateContextConsumer>{crate =>
                                    <div className={"add-to-crate " + (crate.find(item => item.media[0].id == media.id) == undefined ? 'add ' : 'remove ') + ((addingToCrate && addingToCrate == media.id) ? 'adding' : '')}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (crate.find(item => item.media[0].id == media.id) == undefined) {
                                                this.addToCrate(media, e.currentTarget)
                                            } else {
                                                this.removeFromCrate(media)
                                            }
                                        }}>
                                        {addingToCrate && addingToCrate == media.id && <Loader size={25} />}
                                    </div>
                                }</CrateContextConsumer>
                            </div>
                        </div>
                    },
                    playColumn: function (album, playerContext) {
                        const albumPlaying = this.isAlbumSelected(album, playerContext)
                        return <div className='hover-play'>
                            <span className='number'>{self.state.albums!.findIndex(a => a.id == album.id) + 1}</span>
                            <span className='play-pause' onClick={(e) => {
                                e.stopPropagation()
                                if (playerContext.state >= PlayerState.Loading && albumPlaying) {
                                    this.onPause()
                                } else {
                                    this.onAlbumSelected(album)
                                }
                            }}>
                                {!albumPlaying && <div className='play'>
                                    <img src={PLAY_SMALL_SVG} className='play blue' width={ListView.DefaultPlayPauseSize} />
                                    <img src={PLAY_SMALL_WHITE_SVG} className='play white' width={ListView.DefaultPlayPauseSize} />
                                </div>}
                                {albumPlaying && <div className='pause'>
                                    <img src={PAUSE_SMALL_SVG} className='pause blue' width={ListView.DefaultPlayPauseSize} />
                                    <img src={PAUSE_SMALL_WHITE_SVG} className='pause white' width={ListView.DefaultPlayPauseSize} />
                                </div>}
                            </span>
                        </div>
                    }
                }} />
        }
    }
}
export const ScratchToolsView = withRouter(withToast(ScratchTools))


// WEBPACK FOOTER //
// ./src/pages/ScratchTools.tsx